import React from 'react';
import { Target, Shield, TrendingUp, Users } from 'lucide-react';

const PhilosophySection = () => {
  const principles = [
    {
      icon: <Target size={28} />,
      title: "Customized Programming",
      description: "No cookie-cutter plans. Every program is built specifically for you, considering your goals, limitations, and lifestyle."
    },
    {
      icon: <TrendingUp size={28} />,
      title: "Science-Backed Methods",
      description: "Evidence-based training protocols backed by kinesiology research and proven results with real clients."
    },
    {
      icon: <Shield size={28} />,
      title: "Injury Prevention Focus",
      description: "Smart progression and corrective exercise integration to keep you training consistently and safely long-term."
    },
    {
      icon: <Users size={28} />,
      title: "Sustainable Lifestyle",
      description: "Build habits and systems that last beyond our sessions. Real transformation comes from sustainable change."
    }
  ];

  return (
    <section className="philosophy-section">
      <div className="container">
        <div className="philosophy-content">
          <div className="philosophy-text">
            <span className="section-label">My Approach</span>
            <h2 className="section-title">
              Built From The Ground Up
            </h2>
            <p className="philosophy-description">
              True transformation isn't about quick fixes or trendy workouts. 
              It's about understanding your body, addressing limitations, and 
              building a solid foundation for long-term success.
            </p>
            <p className="philosophy-description">
              I take the time to assess your movement patterns, understand your 
              history, and create a roadmap tailored to where you are today and 
              where you want to be tomorrow. Every exercise, every rep, every 
              progression has a purpose.
            </p>
          </div>
          
          <div className="principles-grid">
            {principles.map((principle, index) => (
              <div key={index} className="principle-card">
                <div className="principle-icon">{principle.icon}</div>
                <h3 className="principle-title">{principle.title}</h3>
                <p className="principle-description">{principle.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
